import { Menu } from '@chakra-ui/react';

const VMenuItem = ({ children, ...props }) => {
  return <Menu.Item {...props}>{children}</Menu.Item>;
};

export default VMenuItem;
